// 接口地址
export const BASEURL = 'https://www.jianerkanggz.com/docan/'
// export const BASEURL = 'http://192.168.0.119:8080/docan/'
// export const BASEURL = 'http://localhost:8080/docan/'
// export const BASEURL = 'http://keihong01.natapp1.cc'
